define([
	'internal_util/Util',
	'view/UIView',
	'amdi18n-loader?!view/nls/WebstartRecoveryStrategyView_strings',
	'lib/jquery'
], function (
	Util,
	UIView,
	Strings,
	jQuery
) {
	'use strict';

	/**
	 * WebstartRecoveryStrategyView class
	 */
	function WebstartRecoveryStrategyView(yesCallbacks, noCallbacks, startClientCallbacks) {
		var _view;

		_view = (function () {
			var $view = jQuery('<div id="skIdS_webstart-recovery-strategy-view">' +
									'<span id="skIdS_webstart-recovery-strategy-text">' + Strings.java_not_detected + '</span>' +
									'<div>' +
										'<button id="skIdS_webstart-recovery-strategy-btn-yes" class="btn btn-default">' + Strings.yes + '</button>' +
										'<button id="skIdS_webstart-recovery-strategy-btn-no" class="btn btn-default">' + Strings.no + '</button>' +
										'<button id="skIdS_webstart-recovery-strategy-btn-ok" class="btn btn-default">' + Strings.start_client + '</button>' +
									'</div>' +
								'</div>');

			$view.find('#skIdS_webstart-recovery-strategy-btn-yes').on('click', function () {
				Util.callCallbacks(yesCallbacks);
			});

			$view.find('#skIdS_webstart-recovery-strategy-btn-no').on('click', function () {
				$view.find('#skIdS_webstart-recovery-strategy-text').html(Strings.install_and_start);
				$view.find('#skIdS_webstart-recovery-strategy-btn-no').hide();
				$view.find('#skIdS_webstart-recovery-strategy-btn-yes').hide();
				$view.find('#skIdS_webstart-recovery-strategy-btn-ok').show();

				Util.callCallbacks(noCallbacks);
			});

			$view.find('#skIdS_webstart-recovery-strategy-btn-ok').on('click', function () {
				Util.callCallbacks(startClientCallbacks);
			}).hide();

			return $view;
		})();

		UIView.call(this);


		// public methods

		this.get = function () {
			return _view;
		}

		this.update = function () {
			// nothing to do
		};
	}

	WebstartRecoveryStrategyView.prototype = Object.create(UIView.prototype);

	return WebstartRecoveryStrategyView;
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/WebstartRecoveryStrategyView.js
// module id = 313
// module chunks = 1